import { DetailsList, Icon, IconButton, SelectionMode } from "@fluentui/react";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import AuthContext from "../../Services/AuthContext";
import AddVentureMilestone from "../../Panel/VentureMilestone/AddVentureMilestone";
import EditVentureMilestone from "../../Panel/VentureMilestone/EditVentureMilestone";

function VentureMilestone() {
    const [user] = useContext(AuthContext);
    const {actions} = useOutletContext();
    const [milestones, setMilestones] = useState([]);
    const [refresh, setRefresh] = useState(0);
    const [sum, setSum] = useState(0);
    const params = useParams();
    useEffect(() => {
        const abortController = new AbortController();
        async function fetchData() {
            await fetch(`/api/venture/${params.id}/milestone`, {
                method: 'GET',
                signal: abortController.signal,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    setVenture(data[0].venture);
                    if (data[0].id !== null) {
                        setMilestones(data);
                        setSum(data.reduce((p, c) => (p + c.completion), 0));
                    } else {
                        setMilestones([]);
                        setSum(0);
                    }
                })
                .catch(err => { console.log(err) })
        }
        fetchData();
        return () => abortController.abort();
    }, [params, refresh, user.token]);
    useEffect(() => {
        actions([
            {
                key: 'addMilestone',
                text: 'Dodaj',
                iconProps: { iconName: 'Add' },
                onClick: () => setAddMilestone({venture_id: params.id})
            }
        ]);
        return actions;
    }, []);

    const [addMilestone, setAddMilestone] = useState(false);
    const [editMilestone, setEditMilestone] = useState(false);

    const deleteMilestone = (id) => {
        fetch(`/api/venture/${params.id}/milestone/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { setRefresh(refresh + 1) })
            .catch(err => { console.log(err) })
    }

    const columns = [
        {
            key: 'name',
            name: 'Nazwa',
            ariaLabel: 'Opis kamienia milowego',
            fieldName: 'name',
            minWidth: 200,
            isRowHeader: true,
            isResizable: true
        },
        {
            key: 'description',
            name: 'Opis',
            ariaLabel: 'Opis kamienia milowego',
            fieldName: 'description',
            minWidth: 60,
            isResizable: true,
            onRender: (item) => (<Icon iconName={'info'} title={item.description}></Icon> )
        },
        {
            key: 'date',
            name: 'Data',
            ariaLabel: 'Termin kamienia milowego',
            fieldName: 'date',
            minWidth: 100,
            isResizable: false,
        },
        {
            key: 'completion',
            name: 'Udział',
            ariaLabel: 'Bazowa wartość projektu',
            fieldName: 'project_value',
            minWidth: 120,
            isResizable: false,
            onRender: (item) => `${item.completion}%`
        },
        {
            key: 'id',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            minWidth: 120,
            onRender: (item) => (<>
                    <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditMilestone(item)}/>
                    <IconButton iconProps={ {iconName: 'trash' }} title='Usuń' onClick={() => deleteMilestone(item.id)}/>
                </>)
        }
    ];
    const sumColor = sum !== 100 ? {color: 'orangered'} : {};

    return (
        <>
            <h3 style={sumColor}>Razem: {sum}%</h3>
            <DetailsList items={milestones} columns={columns} selectionMode={SelectionMode.none}/>
            <AddVentureMilestone add={addMilestone} dismissPanel={() => setAddMilestone(false)} onSuccess={() => setRefresh(refresh + 1)}/>
            <EditVentureMilestone edit={editMilestone} dismissPanel={() => setEditMilestone(false)} onSuccess={() => setRefresh(refresh + 1)}/>
        </>
    );
}

export default VentureMilestone;